export default {
  key: 'C',
  suffix: 'aug7',
  positions: [{
    frets: '1001',
    fingers: '1002'
  }, {
    frets: '3443',
    fingers: '1432'
  }, {
    frets: '5867',
    fingers: '1423'
  }, {
    frets: '9a8b',
    fingers: '2314'
  }]
};